import { car } from './../entities/car';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from } from 'rxjs';
//import { ResponseApi } from '../entities/ResponseApi';
import * as moment from 'moment';
import { RecaptchaComponent } from "ng-recaptcha";


declare var _stolenCarUrl: any;
declare var _key: any;

@Component({
  selector: 'app-stolen-car',
  templateUrl: './stolen-car.component.html',
  styleUrls: ['./stolen-car.component.css']
})
export class StolenCarComponent implements OnInit {
  fgInputs: FormGroup;
  isSubmit = false;
  isReturn:boolean = false;
  isLaoding = false;
  dateUpdate: string;
  isStolen: string;
  categoryColor: string;
  stolenCar: car;

  @ViewChild(RecaptchaComponent) recaptcha: RecaptchaComponent;
  public secret: string = _key;

  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.stolenCar =new car();
    this.fgInputs = new FormGroup({
      plateNumber: new FormControl('', { validators: [Validators.required, Validators.maxLength(8), Validators.pattern('^[A-Za-z0-9]+$')] }),
      isSubmit: new FormControl('0'),
      reset: new FormControl('1')
    });
  }

  ngOnInit() {
    this.http.get<string>(_stolenCarUrl + '/sc/')
      .subscribe(c => { this.dateUpdate = moment(c).format("HH:mm DD/MM/YYYY"); });
  }
  resolved(captchaResponse: string) {
    
    this.isSubmit = true;
    //console.log('resolved');
    //debugger;
    if (this.fgInputs.valid ) {
      if (captchaResponse) {
        this.stolenCar.GoogleResponseToken = captchaResponse;
        this.stolenCar.licensePlate = this.fgInputs.get('plateNumber').value;
        
        let httpHeaders = new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        });
        let options = {
          headers: httpHeaders
        };

        this.http.post<boolean>(_stolenCarUrl + '/sc/', this.stolenCar, options).subscribe(r => {
          this.isReturn = true;
          if (r) {
            //console.log('r = true');
            this.isStolen = 'הרכב גנוב';
            this.categoryColor = 'red';
          } else {
            //console.log('r = f');
            this.isStolen = 'הרכב לא מופיע במאגר כרכב גנוב';
            this.categoryColor = 'green';

          }
          this.recaptcha.reset();
          //console.log('end seccses call');
        }, err => {
          this.isReturn = true;
          this.isStolen = 'אירעה שגיאה בלתי צפויה, יש לנסות במועד מאוחר יותר';
          this.categoryColor = 'red';
          this.recaptcha.reset();
        });
      }
    }else if (captchaResponse){
      this.recaptcha.reset();
    }
    this.isLaoding = false;
  }
  send() {
    this.isReturn = false;
    this.isLaoding = true;
    //console.log('send');
    this.recaptcha.execute();
  }

  SetErrorClass() {
    if ((this.fgInputs.get('plateNumber').dirty || this.isSubmit) && this.fgInputs.get('plateNumber').hasError('required')) {
      return true;
    }
    return false
  }

}
